import { type DateRange } from "@src/appV2/lib/Calendar/types";

import { formatTime } from "./formatTime";

interface FormatTimeRangeOptions {
  timezone?: string;
  useNowForStartDate?: boolean;
}

/**
 * Formats a date range into a string in the format "9:30 am - 2:15 pm"
 */
export function formatTimeRange(
  dateRange: DateRange,
  options: FormatTimeRangeOptions = {}
): string {
  const { timezone, useNowForStartDate = false } = options;

  const startTime = useNowForStartDate
    ? "Now"
    : formatTime(dateRange.startDate, timezone).toLowerCase();

  const endTime = formatTime(dateRange.endDate, timezone).toLowerCase();

  return `${startTime} - ${endTime}`;
}
